import React, {Component} from 'react';
import {
  Nav,
  NavItem,
  NavbarToggler,
  NavbarBrand,
} from 'reactstrap';

class Header extends Component {
  constructor(props){
    super(props);
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
    document.body.classList.toggle('sidebar-mobile-show');
    document.body.classList.toggle('sidebar-minimized');    
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }


  render() {
    return (
      <div className="pageHeader">
        <div className="emptyMain"/>
        <div
            className="sidebarHamburger"
            onClick={this.sidebarToggle}
        >
          <i 
            className="fa fa-bars"
            id="menuHamburgerIcon"
          >
          </i>
        </div>
        
        <div className="pageTitle">
          {this.props.pageName}
        </div>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js